import { USER_STATUS } from "../components/common/UserListTable";

export const DEFAULT_ROLE_OPTIONS = [
    { role: "ALL", displayName: "All" },
    { role: "SUPER_ADMIN", displayName: "Super Admin" },
    { role: "ORG_ADMIN", displayName: "Organization Admin" },
    { role: "FINLEY_USER", displayName: "Finley User" },
    { role: "FINANCIAL_COACH", displayName: "Coach" },
];

export const DEFAULT_STATUS_OPTIONS = [
    { status: "ALL", displayName: "All" },
    { status: USER_STATUS.ACTIVE, displayName: "Active" },
    { status: USER_STATUS.INVITED, displayName: "Invited" },
    { status: USER_STATUS.DEACTIVATED, displayName: "Deactivated" },
    { status: USER_STATUS.SIGNED_UP, displayName: "Signed Up" },
];
